import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\"><defs><style></style></defs><path d=\"M307 955.7H198.5c-31.8 0-57.6-25.8-57.6-57.6V125.9c0-31.8 25.8-57.6 57.6-57.6H307c31.8 0 57.6 25.8 57.6 57.6v772.2c0 31.8-25.8 57.6-57.6 57.6zm518.5 0H717c-31.8 0-57.6-25.8-57.6-57.6V125.9c0-31.8 25.8-57.6 57.6-57.6h108.5c31.8 0 57.6 25.8 57.6 57.6v772.2c0 31.8-25.8 57.6-57.6 57.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol